import React from 'react'
import '@yaireo/tagify/dist/tagify.css'
import {connect} from 'react-redux'
import Button from 'material-ui/RaisedButton'
import userService from '../../../services/user-service'

class MembershipPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: null
    }
  }

  componentDidMount = async () => {
    this.setState({ user: await userService.getCurrentUser() })
  };

  formatCsvRecord = (record) => {
    const {mobile, status, data, membershipNumber, createdAt} = record
    return [
      data.businessName || '',
      mobile || '',
      data.email || '',
      membershipNumber || '',
      `${data.firstName || ''} ${data.middleName || ''} ${data.lastName || ''}`,
      status || '',
      data.gstNumber || '',
      createdAt || ''
    ]
  }

  handleClick = async () => {
    const {user} = this.state
    const data = await userService.getAllMemberships(user.tenantId)
    let csvContent = 'data:text/csv;charset=utf-8,' +
      'Business Name,Business Number,Business Email,Membership Number,Name,Status Of Approval,GST Number,Date\n' +
      data.map(e => this.formatCsvRecord(e)).join('\n')
    let encodedUri = encodeURI(csvContent)
    window.open(encodedUri)
  }

  render() {
    return (
      <div style={{textAlign: 'center', padding: 20}}>
        <Button
          backgroundColor='#F2755F'
          onClick={() => this.handleClick()}
        >
          <div style={{marginLeft: 10, marginRight: 10, color: '#FFF'}}>Download Membership Data</div>
        </Button>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loginState: state.loginState
  }
}

export default connect(mapStateToProps)(MembershipPage)



// WEBPACK FOOTER //
// ./src/routes/MembershipPage/containers/index.js